import { Button, Center, Stack, Text, Title } from '@mantine/core'
import * as Sentry from '@sentry/react'
import { IconAlertTriangle } from '@tabler/icons-react'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

const DefaultFallback = ({ resetError }: { resetError: () => void }) => (
  <Center h="100vh">
    <Stack align="center" gap="md">
      <IconAlertTriangle size={48} color="var(--mantine-color-red-6)" />
      <Title order={3}>Something went wrong</Title>
      <Text c="dimmed" size="sm" maw={400} ta="center">
        An unexpected error occurred. Please try refreshing the page or contact support if the problem persists.
      </Text>
      <Button variant="light" onClick={resetError}>
        Try Again
      </Button>
    </Stack>
  </Center>
)

export const ErrorBoundary = ({ children, fallback }: Props) => (
  <Sentry.ErrorBoundary
    fallback={({ resetError }) => (fallback ? <>{fallback}</> : <DefaultFallback resetError={resetError} />)}
    onError={(error, componentStack) => {
      console.error('ErrorBoundary caught an error:', error, componentStack)
    }}
  >
    {children}
  </Sentry.ErrorBoundary>
)
